module.exports = __webpack_public_path__ + "static/media/resume.2d5d55c5.svg";